import { render, staticRenderFns } from "./CopyrightComponent.vue?vue&type=template&id=59e28c52&"
import script from "./CopyrightComponent.vue?vue&type=script&lang=js&"
export * from "./CopyrightComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports